import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema7 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema7_Analisis_Datos.pdf`;
  /*const pdfUrl = "/pdf/Tema7_Analisis_Datos.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 7: Análisis de Datos</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema7;
